'use strict';

function encodeAndEscapeURIComponent(str) {
  return encodeURIComponent(str).replace(/\'/g, "\\'");
}

Groupon.SharingButtons = class SharingButtons {
  constructor({
    el,
    merchantPage,
    facebookSelector,
    twitterSelector,
    emailSelector,
  }) {
    this.facebookShare = this.facebookShare.bind(this);
    this.twitterShare = this.twitterShare.bind(this);
    this.emailShare = this.emailShare.bind(this);
    this.merchantPage = merchantPage;

    if (facebookSelector == null) {
      facebookSelector = '.icon-facebook';
    }

    if (emailSelector == null) {
      emailSelector = '.icon-email';
    }

    if (twitterSelector == null) {
      twitterSelector = '.icon-twitter';
    }

    this.$el = $(el);
    this.$el.find(facebookSelector).on('click', this.facebookShare);
    this.$el.find(twitterSelector).on('click', this.twitterShare);
    this.$el.find(emailSelector).on('click', this.emailShare);
    this;
  }

  popUpOptions(width = 600, height = 450) {
    const left = Math.floor(Math.abs($(window).width() - width) / 2);
    const top = Math.floor(Math.abs($(window).height() - height) / 2);
    return `status=1,width=${width},height=${height},left=${left},top=${top}`;
  }

  facebookShare(e) {
    e.preventDefault();
    let url = this.constructMerchantPageLinkWithTracking('facebook');
    url = `https://www.facebook.com/sharer/sharer.php?u=${encodeAndEscapeURIComponent(
      url
    )}`;
    return window.open(url, 'facebook', this.popUpOptions());
  }

  twitterShare(e) {
    e.preventDefault();
    let url = this.constructMerchantPageLinkWithTracking('twitter');
    const text = this.merchantPage.twitterBody;
    url = `http://twitter.com/share?url=${encodeAndEscapeURIComponent(
      url
    )}&text=${encodeAndEscapeURIComponent(text)}`;
    return window.open(url, 'tweet', this.popUpOptions());
  }

  emailShare(e) {
    e.preventDefault();
    const link = this.constructMerchantPageLinkWithTracking('email');
    const subject = this.merchantPage.emailSubject;
    const body = `${this.merchantPage.emailBody}\n\n${link}`;
    return window.open(
      `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
        body
      )}`,
      'email',
      this.popUpOptions()
    );
  }

  constructMerchantPageLink(permalink) {
    return `https://${window.location.host}/biz/${permalink}`;
  }

  constructMerchantPageLinkWithTracking(medium) {
    const queryParams = _.extend(this.merchantPage.queryParams || {}, {
      utm_campaign: this.merchantPage.campaign,
      utm_medium: medium,
    });

    return `${this.constructMerchantPageLink(
      this.merchantPage.permalink
    )}?${$.param(queryParams)}`;
  }
};
